import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo') as string)
    : null,
  firstLoginStep: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;

      localStorage.setItem('userInfo', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
      localStorage.removeItem('authToken');
    },
    setFirstLoginStep: (state, { payload }) => {
      state.firstLoginStep = payload;
    }
  },
});

export const { setCredentials, logout, setFirstLoginStep } = authSlice.actions;

export default authSlice.reducer;
